import React from 'react'
import { Row } from 'react-bootstrap'
import { i18nTranslate } from 'src/utils'
import { CartProducts } from 'src/views/components'
import './styles.scss'

class SaveForLater extends React.Component {
  render() {
    const { isCheckout = false } = this.props
    return (
      <div className=" saveForLater">
        <Row
          noGutters
          className={`font-weight-bold ml-3 ml-md-0 saveforlater-title heading-3-bold d-flex align-items-center ${
            isCheckout ? '' : 'pl-3'
          }`}>
          <h2 className="m-0">{i18nTranslate('cart.saved', 'Saved')}</h2>
        </Row>
        <Row noGutters data-testid="qa-saved-products">
          <CartProducts
            isCheckout={isCheckout}
            isSaveForLater={true}
            className={`${isCheckout ? '' : 'my-2'}`}
            history={this.props.history}
          />
        </Row>
      </div>
    )
  }
}

export { SaveForLater }
export default SaveForLater
